export default __webpack_public_path__ + "static/media/molly-black.fec9b97e.svg";